import { useState } from "react";
import { Building, Car, Cloud, Flame, Fuel, Landmark, Laptop, Phone, Shield, Smartphone, Wifi, Zap, Calculator, Package } from "lucide-react";

export const SERVICE_ICON = { electricite: Zap, gaz: Flame, carburant: Fuel, telecom: Wifi, mobile: Smartphone, hebergement: Cloud, logiciels: Laptop,
  assurance: Shield, banque: Landmark, locaux: Building, vehicules: Car, comptabilite: Calculator, autre: Package, phone: Phone };

export const ProviderLogo = ({ p, className = "h-10 w-10" }) => {
  const [err, setErr] = useState(false);
  const Icon = SERVICE_ICON[p.service] || Package;
  if (p.domain && !err) {
    return <img src={`${process.env.REACT_APP_BACKEND_URL}/api/logos/${p.domain}`} alt={p.provider} onError={() => setErr(true)}
      className={`shrink-0 rounded-xl bg-white object-contain p-1.5 ${className}`} data-testid={`provider-logo-${p.id || p.provider}`} />;
  }
  return <span className={`flex shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary ${className}`}><Icon className="h-1/2 w-1/2" /></span>;
};
